export function ElearningFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/elearning-filled.svg'"></ng-include>`
    }
}